import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TIMEZONE_LIST } from '../../common/constants/timezones';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { markRequiredControlWithAsteriskSymbol } from '../../common/utils/helpers';
import { IconNames } from '../../common/constants/icon-names';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-select-timezone',
  imports: [CommonModule, IntrackFeatureModule, TranslateModule, SvgIconComponent],
  templateUrl: './select-timezone.component.html',
  styleUrls: ['./select-timezone.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectTimezoneComponent {
  @Input() control: UntypedFormControl;
  @Input() testId: string;
  @Input() tooltipText?: string;

  timezoneList = TIMEZONE_LIST;
  iconNames = IconNames;
  isFieldRequired: (control: AbstractControl) => string = markRequiredControlWithAsteriskSymbol;
}
